import React from 'react'
import Contact from '../Contacts/contact'
import ContactMail from '../Contacts/contactMail'
import HeroContact from '../HeroContact';
import Footer from '../../Footer/Footer';
import '../../App.css';


function ContactPage () {
    return (
        <div>
           <HeroContact/>
           <Contact/>
           <ContactMail/>
           <Footer />
        </div>
    );
}

export default ContactPage;